<template>
  <div class="search-list-select">
    <div class="search-list-select__search mb-1">
      <common-search-field
        v-if="search"
        v-model="searchQuery"
        placeholder="Найти"
        :disabled="disabled"
      />
    </div>

    <div
      v-show="!disabled"
      class="search-list-select__list"
    >
      <selection-list
        :items="items"
        :value="value"
        :mandatory="mandatory"
        :search-query="searchQuery"
        @change="handleSelect"
        @input="handleInput"
      >
        <template #not-found>
          <div class="mt-14 d-flex flex-column align-center">
            <img
              class="mb-6"
              src="/static/_v1/pd/icons/empty-search-result/common.svg"
              width="60"
              height="60"
            >
            <span class="text-body-1 text--text">Мы ничего не нашли</span>
          </div>
        </template>

        <template #item-content="{ item }">
          <slot
            name="list-item-content"
            v-bind="{ item }"
          />
        </template>
      </selection-list>
    </div>
  </div>
</template>

<script>
import CommonSearchField from 'www/vue_components/common/CommonSearchField/CommonSearchField.vue'
import SelectionList from 'www/vue_components/common/core/SelectionList.vue'

export default {
  name: 'SearchListSelect',
  components: {
    CommonSearchField,
    SelectionList,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Object, String],
      default: '',
    },
    disabled: Boolean,
    search: Boolean,
    mandatory: Boolean,
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    selectedItem() {
      return this.items.find(item => item.value === this.value)
    },
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler(val) {
        this.$emit('search', val)
      },
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)

      if (this.value === value && this.closeBySelection) {
        this.closeMenu()
      }
    },
    handleSelect(value) {
      this.$emit('change', value)

      if (this.closeBySelection) {
        this.closeMenu()
      }
    },
    resetSearch() {
      this.searchQuery = ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.search-list-select {
  display: flex;
  flex-flow: column;

  &__search {
    flex: 0 0 auto;
  }

  &__list {
    overflow: hidden auto;
    flex: 1 1 auto;
  }
}
</style>
